<template>
  <div class="animated fadeIn">
      <b-row>
         <b-col sm="12" md="12">
            <b-card class="card-accent-info" header="Card with info accent">
                <div class="bd-example">
                  <dl class="row">
                      <dt class="col-sm-2">Gerant</dt>
                      <dd class="col-sm-3">A description list is perfect for defining terms.</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Nom commercial</dt>
                      <dd class="col-sm-3">A description list is perfect for defining terms.</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Solde</dt>
                      <dd class="col-sm-3">A description list is perfect for defining terms.</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Email</dt>
                      <dd class="col-sm-3">A description list is perfect for defining terms.</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Téléphone</dt>
                      <dd class="col-sm-3">A description list is perfect for defining terms.</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Type</dt>
                      <dd class="col-sm-3">A description list is perfect for defining terms.</dd>
                  </dl>
                </div>
            </b-card>
          </b-col>
      </b-row>
  </div>
</template>

<script>
export default {
  name: 'tables'
}
</script>
